import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link } from '@inertiajs/react'

export default function UsersIndex({ users }) {
  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <h1 className="text-2xl font-bold text-gray-900">Användare</h1>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {users.length === 0 && (
            <p className="px-4 py-12 text-center text-gray-500 text-sm">Inga användare ännu.</p>
          )}
          {users.map(u => (
            <Link
              key={u.id}
              href={`/users/${u.id}`}
              className="flex items-center justify-between px-4 py-4 hover:bg-gray-50"
            >
              <div>
                <p className="font-medium text-gray-900">{u.name}</p>
                <p className="text-sm text-gray-500">{u.email}</p>
              </div>
              <div className="text-right">
                {u.org_admin && (
                  <span className="text-xs font-medium bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full">
                    Organisationsadmin
                  </span>
                )}
                <p className="text-sm text-gray-500 mt-1">
                  {u.teams.map(t => t.name).join(', ') || 'Inga lag'}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
